import { createUseStyles } from "react-jss";
import { colors } from "../../../styles/colors";
const useStyles = createUseStyles({
  contentMain: {
    overflow: "hidden",
    height: "var(--app-vh)",
  },
  containerHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "15px 0px 15px 0px",
  },
  vehiculeRoot: {
    padding: "30px clamp(16px, 3vw, 30px)",
    overflowY: "auto",
    height: "var(--app-vh)",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    backgroundColor: colors.bgcolor,
    // Let the table card fill remaining height so the paginator stays visible.

    "& > div:last-child": { flex: "1 1 auto", minHeight: 0 },

    "@media (max-width:899.95px)": { paddingTop: "68px" },
  },
});

export default useStyles;
